import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MenuModule} from 'primeng/menu';
import {ButtonModule} from 'primeng/button';
import {InputTextModule} from 'primeng/inputtext';
import {CheckboxModule} from 'primeng/checkbox';
import {CalendarModule} from 'primeng/calendar';
import {RadioButtonModule} from 'primeng/radiobutton';
import {FileUploadModule} from 'primeng/fileupload';
import {MessagesModule} from 'primeng/messages';
import {MessageModule} from 'primeng/message';
import {DialogModule} from 'primeng/dialog';
import {ListboxModule} from 'primeng/listbox';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {TableModule} from 'primeng/table';
import {DividerModule} from 'primeng/divider';
import {ToolbarModule} from 'primeng/toolbar';
import {VirtualScrollerModule} from 'primeng/virtualscroller';
import {CardModule} from 'primeng/card';
import {DropdownModule} from 'primeng/dropdown';
import {InputNumberModule} from 'primeng/inputnumber';
import {ColorPickerModule} from 'primeng/colorpicker';
import {InplaceModule} from 'primeng/inplace';
import {AccordionModule} from 'primeng/accordion';
import {ScrollPanelModule} from 'primeng/scrollpanel';
import {TabViewModule} from 'primeng/tabview';
import {AvatarModule} from 'primeng/avatar';
import {OrderListModule} from 'primeng/orderlist';
import {DragDropModule} from 'primeng/dragdrop';
import {DynamicDialogModule} from 'primeng/dynamicdialog';
import {FieldsetModule} from 'primeng/fieldset';
import {SelectButtonModule} from 'primeng/selectbutton';
import {InputSwitchModule} from 'primeng/inputswitch';
import {FocusTrapModule} from 'primeng/focustrap';
import {SplitButtonModule} from 'primeng/splitbutton';
import {InputMaskModule} from 'primeng/inputmask';
import {PasswordModule} from 'primeng/password';
import {GalleriaModule} from 'primeng/galleria';
import {TreeModule} from 'primeng/tree';
import {StepsModule} from 'primeng/steps';
import {DataViewModule} from 'primeng/dataview';
import {ToggleButtonModule} from 'primeng/togglebutton';
import {TooltipModule} from 'primeng/tooltip';
import { TagModule } from 'primeng/tag';
import {ConfirmPopupModule} from 'primeng/confirmpopup';
import {MultiSelectModule} from 'primeng/multiselect';
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MenuModule,
    TagModule,
    ButtonModule,
    InputTextModule,
    CheckboxModule,
    CalendarModule,
    RadioButtonModule,
    FileUploadModule,
    MessagesModule,
    MessageModule,
    DialogModule,
    ListboxModule,
    AutoCompleteModule,
    TableModule,
    DividerModule,
    ToolbarModule,
    VirtualScrollerModule,
    CardModule,
    DropdownModule,
    InputNumberModule,
    ColorPickerModule,
    InplaceModule,
    AccordionModule,
    ScrollPanelModule,
    TabViewModule,
    AvatarModule,
    OrderListModule,
    DragDropModule,
    DynamicDialogModule,
    FieldsetModule,
    SelectButtonModule,
    InputSwitchModule,
    FocusTrapModule,
    SplitButtonModule,
    InputMaskModule,
    PasswordModule,
    GalleriaModule,
    TreeModule,
    StepsModule,
    DataViewModule,
    ToggleButtonModule,
    TooltipModule,
    ConfirmPopupModule,
    MultiSelectModule
  ],
  exports:[
    ButtonModule,
    MenuModule,
    InputTextModule,
    TagModule,
    CheckboxModule,
    CalendarModule,
    RadioButtonModule,
    FileUploadModule,
    MessagesModule,
    MessageModule,
    DialogModule,
    ListboxModule,
    AutoCompleteModule,
    TableModule,
    DividerModule,
    ToolbarModule,
    VirtualScrollerModule,
    CardModule,
    ConfirmPopupModule,
    DropdownModule,
    InputNumberModule,
    ColorPickerModule,
    InplaceModule,
    AccordionModule,
    ScrollPanelModule,
    TabViewModule,
    AvatarModule,
    OrderListModule,
    DragDropModule,
    DynamicDialogModule,
    FieldsetModule,
    SelectButtonModule,
    InputSwitchModule,
    FocusTrapModule,
    SplitButtonModule,
    InputMaskModule,
    PasswordModule,
    GalleriaModule,
    TreeModule,
    StepsModule,
    DataViewModule,
    ToggleButtonModule,
    TooltipModule,
    MultiSelectModule
  ]
})
export class NgPrimeModule { }
